<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface ProseTableProps {
  class?: HTMLAttributes['class']
}

export interface ProseTableSlots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseTableProps>()
defineSlots<ProseTableSlots>()
</script>

<template>
  <div
    class="my-4 overflow-x-auto border border-gray-300"
    :class="props.class"
  >
    <table
      class="
        w-full
        table-auto
        border-collapse
        [&_td:last-of-type]:border-r-0
        [&_td]:min-w-[150px]
        [&_td]:border-b
        [&_td]:border-r
        [&_td]:border-gray-300
        [&_td]:p-2
        [&_th:last-of-type]:border-r-0
        [&_th]:border-b
        [&_th]:border-r
        [&_th]:border-gray-300
        [&_th]:p-2
      "
    >
      <slot />
    </table>
  </div>
</template>
